import { useCallback, useEffect, useState } from 'react'

import { MUI_STANDARD_TRANSITION_DURATION } from '@/constants/mui'

/**
 * Hook that manages dialog visibility state with delayed unmounting for animations
 * @param initialState Initial open state of the dialog
 * @param delay Delay in ms before unmounting when becoming invisible
 * @returns Object with state and handlers for dialog visibility
 */
export const useUnmountingDelay = (
  initialState = false,
  delay = MUI_STANDARD_TRANSITION_DURATION
) => {
  const [isVisible, setIsVisible] = useState(initialState)
  const [isMounted, setIsMounted] = useState(initialState)

  useEffect(() => {
    if (isVisible) {
      setIsMounted(true)
    } else if (isMounted) {
      const timer = setTimeout(() => {
        setIsMounted(false)
      }, delay)

      return () => clearTimeout(timer)
    }
  }, [isVisible, isMounted, delay])

  const open = useCallback(() => setIsVisible(true), [])
  const close = useCallback(() => setIsVisible(false), [])

  return {
    isOpen: isVisible,
    isMounted,
    open,
    close
  }
}
